import React from "react";
import { Link } from "react-router-dom";
import RouteEnums from "routes/RouteEnums";


const AboutContainer: React.FC = () => {
    const howOldAmI = () : number => {
        const now: any = new Date();
        const dob: any = new Date("2000-01-11T10:36:00");
        return new Date((now - dob)).getFullYear() - 1970;
    }

    return (
        <div className="about-page-container">
            <div className="long-text-container">
                <h2>About me</h2>
                <p>
                    I'm {howOldAmI()} years old guy from Irkutsk, Russia
                </p>
                <p>
                    My interests are physics, math, applied programming and some other science<br/>
                    I am interested in how our world works and rules everything occurs<br/>
                    I was born Irkutsk at the beginning of 2000<br/>
                    Studied at school from 1st class till 7th, then went to lyceum #2<br/>
                    Visited Baikal physics-math school 3 times, 2010-2013<br/>
                    Enjoyed taking part in olympiads by physics, maths and chemistry<br/>
                    Interested in Python programming since spring 2016<br/>

                    After school, I entered a university. I chose ITMO University at Saint-Petersburg
                        and low-temperature physics faculty with a cryogenics speciality. I still do not know was
                        it a good choice or not but I do not regret it<br/>

                    Nowadays I'm a master at MIPT, Moscow. I decided to change my speciality and
                        chose "Cosmology and fundamental interactions". Hard, but extremely interesting<br/>

                    And I ABSOLUTELY like programming, there is no day without it. I work in IT company Emphasoft as a
                        Python backend-developer, but also has a wide range of skills - DBA, frontend, server
                        administration, etc (you can find a list of my skills on <Link to={RouteEnums.EXPERIENCE}>Experience</Link> page)
                </p>
                
                <h2>Social</h2>
                github
                VK
                telegram
                instagram
                curseforge
            </div>
        </div>
    );
}

export default AboutContainer;
